import * as React from "react"
import { Bell } from "lucide-react"
import { Tooltip } from "./tooltip"
import { cn } from "../../lib/utils"

/**
 * SectionHint — a small notification-bell icon that sits next to a section
 * header when that section still needs input (e.g. "Link a customer here").
 * Matches the header notification bell so the cue reads as consistent, quiet
 * guidance rather than an alert. Hover for the prompt; click to jump straight
 * to the relevant action.
 *
 * @param {string} props.label     Tooltip prompt (and accessible label)
 * @param {() => void} [props.onClick]  Optional action (opens the relevant dialog/section)
 * @param {string} [props.className]
 */
export function SectionHint({ label, onClick, className }) {
  return (
    <Tooltip content={label}>
      <button
        type="button"
        onClick={onClick}
        aria-label={label}
        className={cn(
          "relative inline-flex items-center justify-center h-6 w-6 rounded-md text-primary hover:bg-primary/10 transition-colors",
          className
        )}
      >
        <Bell className="h-4 w-4" />
        {/* Attention badge — mirrors the header notification count bubble */}
        <span className="absolute -top-1 -right-1 flex h-3.5 min-w-3.5 items-center justify-center rounded-full bg-primary px-0.5 text-[9px] font-bold leading-none text-primary-foreground">
          !
        </span>
      </button>
    </Tooltip>
  );
}

export default SectionHint
